/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".subtitle[_ngcontent-%COMP%]{color:#231d19;font-family:\"Itau Display\";font-size:24px;font-weight:300;letter-spacing:0;line-height:32px}@media (min-width:1024px){.subtitle[_ngcontent-%COMP%]{font-size:32px;font-weight:300;letter-spacing:-.4px;line-height:32px}}"];
export { styles as styles };
